import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=41520bda&scoped=true&"
var script = {}
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=41520bda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41520bda",
  null
  
)

export default component.exports